module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cr-ebed46008265a3777565bf8c24dd3bda.svg";